import { getRoute } from './routes';
import { useSSRSelector } from 'src/redux';

export const useCheckIfHomePage = () => {
  const { storeDomain, accessPath } = useSSRSelector((state) => ({
    storeDomain: state.storeReducer.store.domain,
    accessPath: state.commonReducer.path,
  }));

  if (typeof accessPath !== 'string') return false;
  let domainWithoutForwardSlash = getRoute('', storeDomain);
  const domainNameLength = domainWithoutForwardSlash?.length;
  if (domainWithoutForwardSlash?.lastIndexOf('/') === domainNameLength - 1) {
    domainWithoutForwardSlash = domainWithoutForwardSlash?.slice(0, domainNameLength - 1);
  }

  const isHomePage = [
    '/',
    '',
    '/' + storeDomain,
    getRoute('/', storeDomain),
    domainWithoutForwardSlash,
  ].includes(accessPath);

  return isHomePage;
};
